import { WorkOrderUpload } from '@/features/Aircrafts/WorkOrderUpload/WorkOrderUpload';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/aircrafts/$aircraftId/work-order-upload',
)({
    component: WorkOrderUpload,
});
